// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideDrawerModalStyles {
  position: fixed;
  top: 0;
  right: 0;
  padding: 32px 26px 24px 26px;
  width: 427px;
  height: 100vh;
  z-index: 1000;
  background: #ffffff;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
}
.SideDrawerModalStyles .closeButton {
  display: flex;
}
.SideDrawerModalStyles .closeButton img {
  margin-left: auto;
}
.SideDrawerModalStyles .drawerOne .header {
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  line-height: 24px;
  text-align: center;
  color: #333333;
  margin-bottom: 12px;
  margin-top: 31px;
  text-align: left;
}
.SideDrawerModalStyles .drawerOne .headerRow {
  display: flex;
  justify-content: space-between;
  margin-top: 32px;
}
.SideDrawerModalStyles .drawerOne .headerRow .leftContainer {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
}
.SideDrawerModalStyles .drawerOne .headerRow .rightContainer .hours {
  height: 26px;
  width: 56px;
  text-align: center;
  border: 1px solid #e47c77;
  color: #e47c77;
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  border-radius: 50px;
  padding: 2px;
  padding-top: 3px;
}
.SideDrawerModalStyles .drawerOne .timeRow {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #505054;
  margin-top: 6px;
}
.SideDrawerModalStyles .drawerOne .nameDataRow {
  margin-top: 32px;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
}
.SideDrawerModalStyles .drawerOne .description {
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #999999;
}
.SideDrawerModalStyles .drawerOne .nameListWrapper {
  margin-top: 4px;
  position: relative;
}
.SideDrawerModalStyles .drawerOne .nameListWrapper .nameTab {
  background-color: #f2f2f2;
  border-radius: 50px;
  padding: 6px 12px;
  height: 32px;
  display: inline-block;
  margin-top: 8px;
  margin-right: 8px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
  cursor: pointer;
}
.SideDrawerModalStyles .drawerTwo .header {
  margin-top: 25px;
  display: flex;
  color: #333333;
}
.SideDrawerModalStyles .drawerTwo .header .image {
  width: 52px;
  height: 52px;
  color: white;
  background: #c1c1c1;
  text-align: center;
  border-radius: 26px;
  padding-top: 16px;
  font-size: 22px;
}
.SideDrawerModalStyles .drawerTwo .header .name {
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  color: #333333;
  margin-left: 12px;
  padding-top: 7px;
}
.SideDrawerModalStyles .drawerTwo .personalInfo {
  margin-bottom: 24px;
}
.SideDrawerModalStyles .drawerTwo .personalInfo .headingWithSettings {
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  margin-top: 32px;
  color: #333333;
  position: relative;
  left: 2px;
  display: flex;
  align-content: space-between;
}
.SideDrawerModalStyles .drawerTwo .personalInfo .label {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #868686;
  display: inline-block;
  margin-top: 10px;
  position: relative;
  right: 4px;
  width: 132px;
}
.SideDrawerModalStyles .drawerTwo .personalInfo .value {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
  display: inline-block;
}
.SideDrawerModalStyles .drawerTwo .personalInfo .greenValue {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #2b6132;
  padding: 2px 6px;
  display: inline-block;
  background-color: #d6eed9;
  border-radius: 4px;
}
.SideDrawerModalStyles .drawerTwo .dividerRow {
  margin-top: 5px;
  display: flex;
  flex-direction: row;
  position: relative;
  top: 20px;
  padding-bottom: 12px;
}
.SideDrawerModalStyles .drawerTwo .dividerRow .labelText {
  position: relative;
  left: 5px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.SideDrawerModalStyles .drawerTwo .dividerRow .icon {
  position: relative;
  bottom: 2px;
}
.SideDrawerModalStyles .drawerTwo .dividerRow .line {
  background-color: #f2f2f2;
  width: 72%;
  margin-left: auto;
  height: 1px;
  position: relative;
  top: 9px;
}
.SideDrawerModalStyles .drawerTwo .buttonRow {
  position: absolute;
  bottom: 30px;
  right: 10px;
}
.SideDrawerModalStyles .drawerTwo .buttonRow .cancelButton {
  padding: 12px 16px;
  gap: 10px;
  width: 192px;
  height: 56px;
  background: #ffffff;
  border: 1px solid #e1e1e1;
  border-radius: 8px;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #505054;
  margin: 4px;
  cursor: pointer;
}
.SideDrawerModalStyles .drawerTwo .buttonRow .confirmButton {
  padding: 12px 16px;
  gap: 10px;
  width: 192px;
  height: 56px;
  background: #075453;
  border: 1px solid #e1e1e1;
  color: #ffffff;
  border-radius: 8px;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  margin: 4px;
  cursor: pointer;
}

.SideDrawerOverlayStyles {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1000;
}`, "",{"version":3,"sources":["webpack://./src/screens/calendarNote/sideDrawer/sideDrawer.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,MAAA;EACA,QAAA;EACA,4BAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,4CAAA;EACA,iCAAA;EACA,kBAAA;AACJ;AACI;EACI,aAAA;AACR;AACQ;EACI,iBAAA;AACZ;AAIQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AAFZ;AAKQ;EACI,aAAA;EACA,8BAAA;EACA,gBAAA;AAHZ;AAIY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAFhB;AAKgB;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AAHpB;AAQQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AANZ;AASQ;EACI,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAPZ;AAUQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AARZ;AAWQ;EACI,eAAA;EACA,kBAAA;AATZ;AAUY;EACI,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AARhB;AAaQ;EACI,gBAAA;EACA,aAAA;EACA,cAAA;AAXZ;AAYY;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AAVhB;AAYY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AAVhB;AAaQ;EACI,mBAAA;AAXZ;AAYY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,4BAAA;AAVhB;AAYY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;AAVhB;AAaY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;AAXhB;AAaY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;AAXhB;AAeQ;EACI,eAAA;EACA,aAAA;EACA,mBAAA;EAEA,kBAAA;EACA,SAAA;EACA,oBAAA;AAdZ;AAgBY;EACI,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAdhB;AAgBY;EACI,kBAAA;EACA,WAAA;AAdhB;AAgBY;EACI,yBAAA;EACA,UAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;AAdhB;AAkBQ;EACI,kBAAA;EACA,YAAA;EACA,WAAA;AAhBZ;AAkBY;EACI,kBAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;AAhBhB;AAmBY;EACI,kBAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AAjBhB;;AAuBA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;AApBJ","sourcesContent":[".SideDrawerModalStyles {\n    position: fixed;\n    top: 0;\n    right: 0;\n    padding: 32px 26px 24px 26px;\n    width: 427px;\n    height: 100vh;\n    z-index: 1000;\n    background: #ffffff;\n    box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n\n    .closeButton {\n        display: flex;\n\n        img {\n            margin-left: auto;\n        }\n    }\n\n    .drawerOne {\n        .header {\n            font-weight: 700;\n            font-size: 28px;\n            line-height: 38px;\n            line-height: 24px;\n            text-align: center;\n            color: #333333;\n            margin-bottom: 12px;\n            margin-top: 31px;\n            text-align: left;\n        }\n\n        .headerRow {\n            display: flex;\n            justify-content: space-between;\n            margin-top: 32px;\n            .leftContainer {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 500;\n                font-size: 16px;\n                line-height: 22px;\n                color: #333333;\n            }\n            .rightContainer {\n                .hours {\n                    height: 26px;\n                    width: 56px;\n                    text-align: center;\n                    border: 1px solid #e47c77;\n                    color: #e47c77;\n                    font-weight: 700;\n                    font-size: 12px;\n                    line-height: 18px;\n                    border-radius: 50px;\n                    padding: 2px;\n                    padding-top: 3px;\n                }\n            }\n        }\n\n        .timeRow {\n            font-weight: 400;\n            font-size: 16px;\n            line-height: 24px;\n            color: #505054;\n            margin-top: 6px;\n        }\n\n        .nameDataRow {\n            margin-top: 32px;\n            font-weight: 500;\n            font-size: 16px;\n            line-height: 22px;\n            color: #333333;\n        }\n\n        .description {\n            font-weight: 400;\n            font-size: 12px;\n            line-height: 18px;\n            color: #999999;\n        }\n\n        .nameListWrapper {\n            margin-top: 4px;\n            position: relative;\n            .nameTab {\n                background-color: #f2f2f2;\n                border-radius: 50px;\n                padding: 6px 12px;\n                height: 32px;\n                display: inline-block;\n                margin-top: 8px;\n                margin-right: 8px;\n                font-weight: 400;\n                font-size: 14px;\n                line-height: 20px;\n                color: #505054;\n                cursor: pointer;\n            }\n        }\n    }\n    .drawerTwo {\n        .header {\n            margin-top: 25px;\n            display: flex;\n            color: #333333;\n            .image { \n                width: 52px;\n                height: 52px;\n                color: white;\n                background: #c1c1c1;\n                text-align: center;\n                border-radius: 26px;\n                padding-top: 16px;\n                font-size: 22px;\n            }\n            .name {\n                font-weight: 700;\n                font-size: 28px;\n                line-height: 38px;\n                color: #333333;\n                margin-left: 12px;\n                padding-top: 7px;\n            }\n        }\n        .personalInfo {\n            margin-bottom: 24px;\n            .headingWithSettings {\n                font-weight: 500;\n                font-size: 16px;\n                line-height: 22px;\n                margin-top: 32px;\n                color: #333333;\n                position: relative;\n                left: 2px;\n                display: flex;\n                align-content: space-between;\n            }\n            .label {\n                font-weight: 500;\n                font-size: 14px;\n                line-height: 20px;\n                color: #868686;\n                display: inline-block;\n                margin-top: 10px;\n                position: relative;\n                right: 4px;\n                width: 132px;\n            }\n\n            .value {\n                font-weight: 400;\n                font-size: 14px;\n                line-height: 20px;\n                color: #333333;\n                display: inline-block;\n            }\n            .greenValue {\n                font-weight: 400;\n                font-size: 14px;\n                line-height: 20px;\n                color: #2b6132;\n                padding: 2px 6px;\n                display: inline-block;\n                background-color: #d6eed9;\n                border-radius: 4px;\n            }\n        }\n\n        .dividerRow {\n            margin-top: 5px;\n            display: flex;\n            flex-direction: row;\n\n            position: relative;\n            top: 20px;\n            padding-bottom: 12px;\n\n            .labelText {\n                position: relative;\n                left: 5px;\n                font-weight: 500;\n                font-size: 14px;\n                line-height: 20px;\n                color: #505054;\n            }\n            .icon {\n                position: relative;\n                bottom: 2px;\n            }\n            .line {\n                background-color: #f2f2f2;\n                width: 72%;\n                margin-left: auto;\n                height: 1px;\n                position: relative;\n                top: 9px;\n            }\n        }\n\n        .buttonRow {\n            position: absolute;\n            bottom: 30px;\n            right: 10px;\n\n            .cancelButton {\n                padding: 12px 16px;\n                gap: 10px;\n                width: 192px;\n                height: 56px;\n                background: #ffffff;\n                border: 1px solid #e1e1e1;\n                border-radius: 8px;\n                font-weight: 700;\n                font-size: 16px;\n                line-height: 22px;\n                text-align: center;\n                color: #505054;\n                margin: 4px;\n                cursor:pointer;\n            }\n\n            .confirmButton {\n                padding: 12px 16px;\n                gap: 10px;\n                width: 192px;\n                height: 56px;\n                background: #075453;\n                border: 1px solid #e1e1e1;\n                color: #ffffff;\n                border-radius: 8px;\n                font-weight: 700;\n                font-size: 16px;\n                line-height: 22px;\n                text-align: center; \n                margin: 4px;\n                cursor:pointer;\n            }\n        }\n    }\n}\n\n.SideDrawerOverlayStyles {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.7);\n    z-index: 1000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
